<template>
    <v-dialog
        width="860"
        height="583"
        :value="showPopUp"
        @input="togglePopUp"
    >
        <v-card>
            <v-toolbar height="40" flat>
                <v-spacer></v-spacer>
                <v-btn 
                    icon 
                    @click.prevent="togglePopUp" 
                    :ripple="false"
                >
                    <v-icon color="black">
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-container class="px-5">
                <div :class="flexClass">
                    <HelpImage
                        v-for="(helpImg, index) in getImages(0, showTwobyTwo ? 2 : 1)"
                        :key="`item-${index}`"
                        :helpImg="helpImg"
                    />
                </div>
                <div class="d-flex justify-space-between">
                    <HelpImage
                        v-for="(helpImg, index) in getImages(showTwobyTwo ? 2 : 1)"
                        :key="`item-${index}`"
                        :helpImg="helpImg"
                    />
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    import HelpImage from '@/components/myHabiteoStudio/steps/components/HelpImage';

    export default {
        name: 'HelpPopUp',
        components: {
            HelpImage
        },
        props: {
            showPopUp: {
                type: Boolean,
                required: true
            },
            helpImage: {
                type: Array,
                default: () => [],
                required: true
            },
            showTwobyTwo: {
                type: Boolean,
                default: false,
                required: true
            }
        },
        computed: {
            flexClass() {
                return this.showTwobyTwo ? 'd-flex justify-space-between' : 'd-flex justify-center';
            }
        },
        methods: {
            togglePopUp() {
                this.$emit('toggle-pop-up');
            },
            getImages(start, end) {
                return this.helpImage.slice(start, end);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/HelpPopUp.vue